import {inject, Injectable} from '@angular/core';
import {FieldType} from "./definitions/field-type.enum";
import {SuperObjectModel} from "./definitions/super-object-model";
import {MetaField} from "./definitions/meta-field";
import {BaseModel} from "./definitions/base-model";
import {SectionsContainer} from "./definitions/sections-container";
import {FieldKeyService} from "./field-key.service";
import {FieldInputType} from "./definitions/field-input-type.enum";
import {SearchReferenceService} from "./search-reference.service";
import {ObjectEditService} from "./object-edit.service";
import {ModelsService} from "./models.service";

@Injectable({
  providedIn: 'root',
})
export class MetaOperationFieldService {
  private readonly fieldKeyService = inject(FieldKeyService);
  private readonly searchReferenceService = inject(SearchReferenceService);
  private readonly objectEditService = inject(ObjectEditService);
  private readonly modelsService = inject(ModelsService);

  private textFieldTypes = [FieldType.TEXT.toString(), FieldType.STRING.toString()];

  async setTheValueObject(
    sectionsContainer: SectionsContainer,
    field: MetaField,
    operationField: MetaField,
    setValueObject: BaseModel,
    myParentIndex: number,
    clearExistingValue: boolean) {
    setValueObject['operation_field'] = operationField;
    const inline = operationField.inline;
    let modelName: string;
    let fieldRequired = false;
    if (operationField.field_type !== FieldType.ARRAY) {
      fieldRequired = operationField.is_required === 'required';
    }
    setValueObject['operation_field_required'] = fieldRequired;
    if (inline) {
      modelName = inline.model;
      setValueObject['operation_inline_prop'] = inline.prop;
      setValueObject['operation_inline_unique_props'] = inline.unique_props;
    } else {
      modelName = sectionsContainer.rootObject.object_type;
    }
    setValueObject['operation_value_is_array'] = operationField.field_type === FieldType.ARRAY;
    setValueObject['operation_value_is_text'] = false;
    setValueObject['select_field_name'] = operationField.field_name;
    // Replace some of the selected field's attributes with the operation field's attributes in order for
    // the operation field value to be set in the correct place within the operation object
    operationField.name = field.name;
    this.fieldKeyService.setFieldKey(operationField, field.key);
    operationField.edit = 'edit';
    const reference = this.searchReferenceService.getSearchReferenceFromField(field);

    const fieldOperationType = reference.field_operation_type;
    if (fieldOperationType !== 'set_value') {
      // When user selects 'replace' or 'delete', the field title needs to be 'replace from value' or 'replace to value'
      operationField.title = field.title;
      // When user selects 'replace' the field cannot be an array so setting field type to "inline"
      if (inline) {
        operationField.field_type = FieldType.INLINE;
        operationField.input_type = FieldInputType.INLINE;
      }
    }
    if (operationField.field_type === FieldType.INLINE) {
      operationField.sub_fields = this.getSubFields(operationField, fieldOperationType, field);
      for (const subField of operationField.sub_fields) {
        this.fieldKeyService.generateFieldKey(subField, field.key);
      }
      setValueObject['operation_value_is_text'] = operationField.sub_fields.filter(
        subField => subField.name === inline.prop).some(
        subField => this.textFieldTypes.includes(subField.field_type));
      // If field type is not array need to add inline fields into form control
      if (clearExistingValue || !setValueObject[field.name]) {
        setValueObject[field.name] = await this.objectEditService.addInlineItem(
          modelName, operationField, sectionsContainer, myParentIndex);
      }
    } else if (operationField.field_type === FieldType.ARRAY) {
      if (clearExistingValue || !setValueObject[field.name]) {
        setValueObject[operationField.name] = [];
        sectionsContainer.parentObject = <SuperObjectModel>setValueObject;
        if (operationField.input_type === FieldInputType.INLINE_ARRAY) {
          for (const inlineField of operationField.inline_fields) {
            inlineField.path = `${field.parent_name}.${field.name}`;
            inlineField.parent_name = field.name;
          }
        } else if (operationField.input_type === FieldInputType.REF_ARRAY) {
          console.log('ye')
        }
      }
    }

  }

  private getSubFields(selectedField: MetaField, fieldOperationType: string, field: MetaField): MetaField[] {
    const useReplaceFieldTitle = fieldOperationType === 'replace' ? !!selectedField.inline.prop : false;
    const subFields = [];
    const meta = this.modelsService.getModelMeta(selectedField.inline.model) || {};
    for (const [subFieldName, subFieldOrig] of Object.entries(meta)) {
      const subField: MetaField = {...subFieldOrig};
      let addField = this.canAddField(selectedField, fieldOperationType, subFieldName, subField);
      if (!addField) {
        continue;
      }
      subFields.push(subField);
      // Must remove required prop to avoid client validation issues
      delete subField.is_required;
      // When user selects 'replace' the field title needs to be 'replace from value' or 'replace to value'
      if (useReplaceFieldTitle && selectedField.inline.prop === subFieldName) {
        subField.title = field.title;
      }
    }
    return subFields;
  }

  private canAddField(selectedField: MetaField, fieldOperationType: string, subFieldName: string, subField: MetaField): boolean {
    let addField = selectedField.inline.prop === subFieldName || (fieldOperationType !== 'replace_from_value' && subField.edit && subField.title && subField.display === 'yes');
    if (addField) {
      // When user selects 'delete' only fields that are part of the inline unique props can be used for determine which items to delete
      addField = !(fieldOperationType === 'delete_value' && selectedField.inline?.unique_props.indexOf(subField.name) === -1);
    }
    return addField;
  }


}
